/**
 * Created by Denis Kuzin on 12 august 2024
 */

const ComboComponentView = cc.Node.extend({
    ctor: function (component, cellView) {
        this._super();

        this.component = component;
        this.cellView = cellView;
    },

    afterInitialize: function () {
        this.component.cell.algoShotAnimation = this.animateShot.bind(this);
    },

    beforeUnuse: function () {
        this.component.cell.algoShotAnimation = function () {};
    },

    targetBlast: function (targetPosition) {
        if (!this.cellView.isRunning() || !this.component.cell || !this.component.cell.algo) {
            return;
        }

        const animation = this.component.cell.algo.blast_animation;

        const blastAnimation = BaseAnimation.factory(animation);
        blastAnimation.setLocalZOrder(22);
        blastAnimation.setPosition(targetPosition);
        this.cellView.parent.addChild(blastAnimation);
        blastAnimation.runAnimate("animation");
        return blastAnimation;
    },

    shots: {
        bezier: function (target, shootDuration) {
            const beginPosition = this.cellView.getPosition();
            const targetPosition = BaseCellView.alignInTheGrid(target.x, target.y);

            const first = cc.p(beginPosition.x, Math.max(beginPosition.y, targetPosition.y) + cleverapps.styles.ComboCellView.shootBeginUp);
            const second = cc.p(targetPosition.x, first.y);
            const rotateAngle = targetPosition.x < beginPosition.x ? -180 : 180;
            const blast = new cc.Sprite(bundles.game.frames.bomb_png);

            blast.setLocalZOrder(21);
            blast.setPosition(beginPosition);
            blast.setScale(0.3);
            this.cellView.parent.addChild(blast);
            blast.runAction(new cc.Sequence(
                new cc.Spawn(
                    new cc.BezierTo(shootDuration, [first, second, targetPosition]).easing(cc.easeIn(1)),
                    new cc.RotateBy(shootDuration, rotateAngle),
                    new cc.ScaleTo(shootDuration / 2, 1)
                ),
                new cc.CallFunc(() => {
                    this.targetBlast(targetPosition);
                }),
                new cc.RemoveSelf()
            ));
        },

        plane: function (target, shootDuration, order) {
            const delay = 0.6;

            if (order === 0) {
                const explosion = new cleverapps.Spine(bundles.game.jsons.plane_combo_spine_json);
                explosion.setAnimation(0, "start", false);
                explosion.setCompleteListenerRemove();
                explosion.setAlignment(BaseCellView.alignInTheGrid(this.component.cell.x, this.component.cell.y));
                this.cellView.parent.addChild(explosion);
                explosion.setLocalZOrder(this.cellView.getLocalZOrder() - 1);
            }

            let skin = "plane_plane";
            const cargo = this.component.cell.algo.cargo;
            if (cargo) {
                if (cargo.name === CombosLibrary.TYPE_LINER) {
                    skin = "plane_linear";
                } else if (cargo.name === CombosLibrary.TYPE_BOMB) {
                    skin = "plane_tnt";
                }
            }

            const animation = new cleverapps.Spine(bundles.game.jsons.plane_combo_spine_json);
            animation.setSkin(skin);
            animation.setAnimation(0, "ignite", false);

            const rocket = new Rocket(this.component.cell, target, {
                delay,
                duration: shootDuration - delay,
                json: this.component.cell.algo.shoot_animation,
                rocket: animation,
                plane: true,
                onLaunch: function () {
                    animation.setAnimation(0, "fly", true);
                    cleverapps.effects.fire("match3.cell.combo.create");
                },
                onArrive: function (callback) {
                    cleverapps.effects.fire("match3.cell.boom");

                    animation.replaceParentSamePlace(cleverapps.Scenes.GetRunningScene(), { keepScale: true });
                    animation.setLocalZOrder(11);
                    animation.setAnimation(0, "splash", false);
                    animation.setCompleteListenerRemove(callback);
                    animation.setRotation(0);
                }
            });
            rocket.setVisible(true);
            this.cellView.parent.addChild(rocket);
            rocket.setLocalZOrder(21);
        },

        rocket: function (target, shootDuration) {
            const rocket = SimpleRocket(this.component.cell, target, {
                delay: 0.2,
                duration: shootDuration,
                json: this.component.cell.algo.shoot_animation
            });
            this.cellView.parent.addChild(rocket);
            rocket.setLocalZOrder(21);
        },

        blast: function (target) {
            const targetPosition = BaseCellView.alignInTheGrid(target.x, target.y);
            this.targetBlast(targetPosition);
        },

        jump: function (target, shootDuration) {
            const targetPosition = BaseCellView.alignInTheGrid(target.x, target.y);
            const goalCoefComponent = this.component.cell.findComponent(GoalCoefComponent);
            const coefView = goalCoefComponent && goalCoefComponent.view;

            shootDuration *= 0.7;
            if (coefView) {
                coefView.setVisible(false);
            }
            this.cellView.setLocalZOrder(22);
            this.cellView.runAction(new cc.Sequence(
                new cc.MoveTo(shootDuration, targetPosition),
                new cc.CallFunc(() => {
                    if (Game.currentGame) {
                        Game.currentGame.shakeField({ delay: 150 });
                    }
                    if (coefView) {
                        coefView.setVisible(true);
                    }
                })
            ));
        },

        throw: function (target, shootDuration) {
            const beginPosition = this.cellView.getPosition();
            let targetPosition;
            if (this.component.cell.algo.getTargetPosition) {
                targetPosition = cc.Base.GetTargetPosition(this.component.cell.algo, target, beginPosition);
            } else {
                targetPosition = BaseCellView.alignInTheGrid(target.x, target.y);
            }
            const goalCoefComponent = this.component.cell.findComponent(GoalCoefComponent);
            const coefView = goalCoefComponent && goalCoefComponent.view;

            shootDuration *= 0.7;
            if (coefView) {
                coefView.setVisible(false);
            }
            const blast = this.targetBlast(beginPosition);
            if (this.component.cell.algo.rotateToTarget) {
                blast.setRotation(Math.atan2(targetPosition.x - beginPosition.x, targetPosition.y - beginPosition.y) * 180 / Math.PI);
            }
            if (blast) {
                const moveAction = new cc.MoveTo(shootDuration, targetPosition);
                if (this.component.cell.algo.applyEasing) {
                    this.component.cell.algo.applyEasing(moveAction);
                }
                const blastExpldeAnimationName = this.component.cell.algo.blast_explde_animation_name;
                blast.runAction(new cc.Sequence(
                    moveAction,
                    new cc.CallFunc(() => {
                        if (Game.currentGame) {
                            Game.currentGame.shakeField({ delay: 150 });
                        }
                        if (coefView) {
                            coefView.setVisible(true);
                        }
                        if (blastExpldeAnimationName) {
                            blast.runAnimate(blastExpldeAnimationName);
                        }
                    })
                ));
            }
        },

        ray: function (target, shootDuration) {
            const start = this.cellView.getPosition();
            const targetPos = BaseCellView.alignInTheGrid(target.x, target.y);

            const animation = new cleverapps.Spine(this.component.cell.algo.shoot_animation);
            animation.setAnimation(0, "idle", true);

            const ray = new cc.Node();
            ray.setAnchorPoint(0.5, 0);
            ray.setContentSize2(animation.getContentSize());
            ray.addChild(animation);
            animation.setAlignment(ray.width / 2, ray.height / 2);
            this.cellView.parent.addChild(ray);
            ray.setLocalZOrder(21);
            ray.setAlignment(start);
            ray.setRotation(Math.atan2(targetPos.x - start.x, targetPos.y - start.y) * 180 / Math.PI);

            const dist = Math.sqrt((targetPos.x - start.x) * (targetPos.x - start.x) + (targetPos.y - start.y) * (targetPos.y - start.y));
            const scaleY = dist / ray.height;
            ray.setScaleY(0);
            ray.runAction(new cc.Sequence(
                new cc.ScaleTo(shootDuration, 1, scaleY),
                new cc.CallFunc(() => {
                    animation.setAnimation(0, "finish", false);
                    animation.setCompleteListenerRemove();
                })
            ));
        },

        none: function () {
        }
    },

    animateShot: function (target, shootDuration, order) {
        const shootAlgorithm = this.shots[this.component.cell.algo.shootAlgorithm];
        shootAlgorithm.call(this, target, shootDuration, order);
    }
});